(ns manatee.auth.view
  "Login form."
  (:require
   [clojure.spec.alpha :as s]
   [manatee.auth.handlers :as handlers]
   [manatee.auth.ids :as ids]
   [manatee.auth.subs :as subs]
   [manatee.components.icon-animated.components :as icon-animated-components]
   [manatee.components.notifications.container :as notifications]
   [manatee.spec.auth :as auth-spec]
   [manatee.ui.templates :as templates]
   [manatee.user.subs :as user-subs]
   [re-frame.core :as rf]))

(defn view
  []
  (let [{:keys [email password] :as payload} @(rf/subscribe [::subs/login-payload])
        payload-valid? (s/valid? ::auth-spec/login-form payload)
        email-dirty? @(rf/subscribe [::subs/email-dirty?])
        email-valid? (s/valid? ::auth-spec/email email)
        password-dirty? @(rf/subscribe [::subs/password-dirty?])
        password-valid? (s/valid? ::auth-spec/password password)
        logging-in? @(rf/subscribe [::user-subs/logging-in?])]
    [:<>
     [notifications/alerts
      {:banner-id  ids/login-alert-banner
       :max-alerts 1}]
     [:div.sign-in-form
      [:h5 "Sign in"]
      [:div.instructions
       [:p "You can sign in with your annotator credentials here:"]]
      [:div.form__input
       [:label.form__label.primary {:for "email"}
        "Email"]
       [:input#email {:auto-focus true
                      :name "email"
                      :type "email"
                      :on-change #(rf/dispatch [::handlers/set-login-email (-> % .-target .-value)])
                      :on-focus #(rf/dispatch [::handlers/set-email-dirty false])
                      :on-blur #(rf/dispatch [::handlers/set-email-dirty true])}]
       (when (and email-dirty?
                  (not email-valid?))
         [:div.form__validation-messages
          [:small.form__validation-message.error "Email must not be empty and must contain '@' and '.'"]])]
      [:div.form__input
       [:label.form__label.primary {:for "password"}
        "Password"]
       [:input#password {:name "password"
                         :type "password"
                         :on-change #(rf/dispatch [::handlers/set-login-password (-> % .-target .-value)])
                         :on-focus #(rf/dispatch [::handlers/set-password-dirty false])
                         :on-blur #(rf/dispatch [::handlers/set-password-dirty true])}]
       (when (and password-dirty?
                  (not password-valid?))
         [:div.form__validation-messages
          [:small.form__validation-message.error "Password must not be empty"]])]

       ; The submit button is enabled only if the form payload is valid and a
       ; log in is not in progress.
      [:button.rothko-btn.primary {:type "button"
                                   :disabled (or (not payload-valid?)
                                                 logging-in?)
                                   :on-click #(rf/dispatch [::handlers/sign-in])}
       (if logging-in?
         [icon-animated-components/spinner {:size 20}]
         "Continue")]]]))

(def page
  {:main view
   :template templates/single-column})
